import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo1.png'; // Import logo from the assets folder

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleMobileMenuToggle = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleMenuLinkClick = () => {
    setIsMobileMenuOpen(false); // Close the mobile menu when a link is clicked
  };

  return (
    <nav className="bg-white text-blue-900 p-4 sticky top-0 z-50 shadow-lg">
      <div className="container mx-auto flex justify-between items-center h-10"> {/* Fixed height for navbar */}
        {/* Logo (on the left) */}
        <div className="flex items-center">
          {/* Display the logo with custom height and width */}
          <img
  src={logo}  // Using the imported logo
  alt="Sigma IT Innovation Logo"
  className="h-16 sm:w-24 md:w-28 lg:w-32 xl:w-36"  // Reduced width values
/>


        </div>

        {/* Navbar Menu (on the right) */}
        <div className="hidden md:flex space-x-6">
          <Link 
            to="/" 
            className="hover:text-blue-300 px-4 py-2 transition duration-300"
            onClick={handleMenuLinkClick} // Close mobile menu on click
          >
            Home
          </Link>
          <Link 
            to="/about" 
            className="hover:text-blue-300 px-4 py-2 transition duration-300"
            onClick={handleMenuLinkClick} // Close mobile menu on click
          >
            About
          </Link>
          <Link 
            to="/services" 
            className="hover:text-blue-300 px-4 py-2 transition duration-300"
            onClick={handleMenuLinkClick} // Close mobile menu on click
          >
            Services
          </Link>
          <Link 
            to="/blog" 
            className="hover:text-blue-300 px-4 py-2 transition duration-300"
            onClick={handleMenuLinkClick} // Close mobile menu on click
          >
            Blog
          </Link>
          <Link 
            to="/contact" 
            className="hover:text-blue-300 px-4 py-2 transition duration-300"
            onClick={handleMenuLinkClick} // Close mobile menu on click
          >
            Contact
          </Link>
        </div>
        
        {/* Mobile Menu Button */}
        <button 
          className="md:hidden text-2xl"
          onClick={handleMobileMenuToggle}
        >
          ☰
        </button>
      </div>

      {/* Mobile Menu */}
      <div className={`${isMobileMenuOpen ? 'block' : 'hidden'} md:hidden`}>
        <div className="flex flex-col space-y-4 items-end py-4">
          <Link 
            to="/" 
            className="hover:text-blue-300 px-4 py-2 transition duration-300 hover:bg-blue-900 "
            onClick={handleMenuLinkClick} // Close mobile menu on click
          >
            Home
          </Link>
          <Link 
            to="/about" 
            className="hover:text-blue-300 px-4 py-2 transition duration-300 hover:bg-blue-900 "
            onClick={handleMenuLinkClick} // Close mobile menu on click
          >
            About
          </Link>
          <Link 
            to="/services" 
            className="hover:text-blue-300 px-4 py-2 transition duration-300 hover:bg-blue-900 "
            onClick={handleMenuLinkClick} // Close mobile menu on click
          >
            Services
          </Link>
          <Link 
            to="/blog" 
            className="hover:text-blue-300 px-4 py-2 transition duration-300 hover:bg-blue-900 "
            onClick={handleMenuLinkClick} // Close mobile menu on click
          >
            Blog
          </Link>
          <Link 
            to="/contact" 
            className="hover:text-blue-300 px-4 py-2 transition duration-300 hover:bg-blue-900 "
            onClick={handleMenuLinkClick} // Close mobile menu on click
          >
            Contact
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
